import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { ArrowLeft24Icon } from '@kaleyra/kds';

import Styles from './KDSLeftSideBar.module.scss';

export type LogoProps = {
	url?: string;
	channelName?: string;
};

const Logo = ({ url, channelName }: LogoProps) => (
	<Link to={url || ''} className={cn(Styles.logoContainer)}>
		<div style={{ marginBottom: 2 }}>
			<ArrowLeft24Icon style={{ fontSize: '24px' }} />
		</div>
		<div className={Styles.channel}>{channelName}</div>
	</Link>
);

export default Logo;
